import type { DocumentFlowDoc } from '@dealstack/shared/lib/common/business/documentFlow';
import { useDocxSignatureSlotsFrom } from '@dealstack/frontend/shared/components/FieldBinding/DocxFieldBinding/useDocxSignatureSlotsFrom.ts';
import { useSignatureSlotsQuery } from '../../api/useSignatureSlotsQuery.ts';

/** The shared slot derivation, reading a deal master document's signing roles. */
export const useDocxSignatureSlots = (templateId: string, document: DocumentFlowDoc | null) => {
	const { data, isPending, isError } = useSignatureSlotsQuery(templateId);
	// The endpoint answers with the date placements alongside (DC-1000); only the slots matter
	// here, since a reflow document places its dates nowhere on this surface.
	return useDocxSignatureSlotsFrom({ slots: data?.slots, isPending, isError, document });
};
